// Reads data embedded by the prerender script (scripts/prerender.js) as a
// <script type="application/json" id="..."> tag, so a page's first client
// render (before its own useEffect fetch resolves) already matches what was
// prerendered — otherwise React 18 hydration always mismatches for any content
// that depends on a useEffect-triggered fetch, since the pre-effect initial
// render is empty/null while the prerendered HTML already has real data.
export function getPreloadedData(key) {
  if (typeof document === "undefined") return null;
  const el = document.getElementById(key);
  if (!el) return null;
  try {
    return JSON.parse(el.textContent);
  } catch (e) {
    return null;
  }
}

// Renders the data a page fetched as a <script type="application/json"> so the
// prerender snapshot carries it and getPreloadedData() can seed the first client
// render. "<" is escaped so record text can never terminate the script tag; the
// same function runs on the server snapshot and the client, so output is identical.
export function PreloadedScript({ id, data }) {
  if (data === null || data === undefined) return null;
  return (
    <script
      type="application/json"
      id={id}
      dangerouslySetInnerHTML={{ __html: JSON.stringify(data).replace(/</g, "\\u003c") }}
    />
  );
}
